import { is } from "app/pages/sales-intelligence/utils/type-guards";

const HTML_TAG_REGEXP = /(<\s*[\/a-z]+[^<>"']*((<[^<>]*>|((["'][^"']+)(?=["'])))[^<>]*)*[^<>]*>)/gi;

export function removeHTMLTags(str: string): string {
    return str.replace(HTML_TAG_REGEXP, "");
}

export function removeHTMLTagsFromSignalNames<V extends Record<string, unknown> = Record<string, string>>(
    namesByIds: V,
): V {
    return Object.keys(namesByIds).reduce((acum, id) => {
        const name = namesByIds[id];

        return is.string(name)
            ? {
                  ...acum,
                  [id]: removeHTMLTags(name),
              }
            : acum;
    }, namesByIds);
}
